import React from "react"
//import I18n from "i18n-js/index.js.erb"
import PaddingInput from "../inputs/PaddingInput"

class PaddingDropdown extends React.Component {

  constructor(props) {
    super(props);
    this._onClick = this._onClick.bind(this);
  }

  render() {
    var props = {
      rowId: this.props.rowId,
      columnId: this.props.columnId
    };

    return (
      <div className="editor-dropdown" onClick={this._onClick}>
        <div className="form-group">
          <label>{I18n.t('padding')}</label>
          <PaddingInput {...props} initialValue={this.props.initialStyle ? this.props.initialStyle.padding : null} onStyleChange={this.props.onStyleChange} />
        </div>
      </div>
    );
  }

  _onClick(event) {
    event.stopPropagation();
    event.preventDefault();
  }

};

export default PaddingDropdown
